import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { SchoolScope, StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface TimeOnTaskHistoryResponse {
  students: {
    student_id: number
    session_count: number
    total_seconds: number
    average_seconds_per_session: number
    average_seconds_per_week: number
  }[]
}

export type TimeOnTaskHistoryDataItem = TimeOnTaskHistoryResponse['students'][number]

export async function timeOnTaskHistory(
  this: StudentEventsService,
  product: LegacyProductRe | LegacyProductRex | LegacyProductMs | LegacyProductFp | LegacyProductWl,
  statsScope: SchoolScope | StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<TimeOnTaskHistoryDataItem[]>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('time_on_task_history', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<TimeOnTaskHistoryResponse>(url, query)
  if (!data) return null

  const { students } = data
  if (students.length === 0) return null

  return students
}

export async function timeOnTaskHistoryV2(
  this: StudentEventsService,
  product: LegacyProductRex,
  statsScope: SchoolScope | StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<TimeOnTaskHistoryDataItem[]>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('time_on_task_history_v2', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<TimeOnTaskHistoryResponse>(url, query)
  if (!data) return null

  const { students } = data
  if (students.length === 0) return null

  return students
}
